import { motion } from 'framer-motion'
import ScrollReveal from '../shared/ScrollReveal'
import { Icons } from '../shared/Icons'
import './ValuePropositionBanner.css'

const valueProps = [
  {
    icon: Icons.alert,
    label: '−80% False Alarms',
    description: 'Cross-validated intelligence'
  },
  {
    icon: Icons.trending,
    label: '30–180 Days Ahead',
    description: 'Failures predicted early'
  },
  {
    icon: Icons.refresh,
    label: 'Real-time Sync',
    description: 'Web ↔ mobile, two-way'
  },
  {
    icon: Icons.bolt,
    label: 'Full Automation',
    description: 'Detect \u2192 Alert \u2192 Maintain'
  },
  {
    icon: Icons.dollarSign,
    label: '€2–3B Saved',
    description: 'Annual EU losses, recovered'
  }
]

export default function ValuePropositionBanner() {
  return (
    <section className="value-banner">
      <div className="container">
        <ScrollReveal>
          <div className="value-banner-strip">
            {valueProps.map((prop, i) => (
              <motion.div
                key={i}
                className="value-item"
                whileHover={{ y: -4 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                viewport={{ once: true }}
              >
                <span className="value-icon">
                  <prop.icon size={24} />
                </span>
                <div className="value-text">
                  <span className="value-label">{prop.label}</span>
                  <span className="value-description">{prop.description}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}
